// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --header-height: 3rem;
  --nav-width: 68px;
  --first-color: #6d28d9;

  --first-color-light: #fdfdfd;
  --white-color: #f7f6fb;

  --body-font: "Montserrat", sans-serif;
  --normal-font-size: 1rem;
  --z-fixed: 100;
}

/* a {
  text-decoration: none;
  color: none;
}

a:hover {
  color: none;
} */

h1 {
  font-family: var(--body-font) !important;
  font-weight: 700;
}

.header_toggle {
  color: var(--first-color);
  font-size: 1.5rem;
  cursor: pointer;
}

.header_img {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
}

.header_img img {
  width: 40px;
}

.l-navbar {
  top: 0;
  width: 100%;
  height: 100vh;
  padding: 0.5rem 1rem 0 0;
  transition: 0.5s;
  z-index: var(--z-fixed);
  position: relative;
  @media (max-width: 575px) {
    height: 95vh;
  }
}

.nav {
  /* height: 100%; */
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  overflow: hidden;
  margin-top: 1rem;
}

.nav_logo,
.nav_link {
  display: flex;
  grid-template-columns: max-content max-content;
  align-items: center;
  column-gap: 1rem;
  padding: 0.5rem 0 0.5rem 1.5rem;
}

.nav_lock_link {
  position: relative;
  margin-bottom: 1.5rem;
  transition: 0.3s;
  bottom: 0;
  /* position: fixed; */
}

.nav_logo {
  margin-bottom: 2rem;
  color: var(--first-color-light);
}

.nav_logo-icon {
  font-size: 1.25rem;
  /* color: var(--white-color); */
}

.nav_logo-name {
  color: var(--white-color);
  font-size: 0.95rem;
  font-weight: 700;
}

.nav_link {
  /* position: relative; */
  /* color: var(--first-color-light); */
  /* margin-bottom: 1.5rem;
  transition: 0.3s;
  bottom: 0; */
  /* position: fixed; */
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  left: 0;
  @media (max-width: 575px) {
    bottom: 40px;
  }
}

.nav_end_link {
  display: flex;
  width: 200px;
  height: 40px;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.nav_logo:hover,
.nav_link:hover {
  /* color: var(--white-color); */
}

.nav_icon {
  font-size: 1.25rem;
}

.show {
  left: 0;
}

.body-pd {
  padding-left: calc(var(--nav-width) + 1rem);
}

/* .active {
  color: var(--white-color);
}

.active::before {
  content: "";
  position: absolute;
  left: 0;
  width: 2px;
  height: 32px;
  background-color: var(--white-color);
} */

@media screen and (min-width: 768px) {
  /* body {
    margin: 0;
    padding-left: 0;
  } */

  .header {
    height: calc(var(--header-height) + 1rem);
    padding: 0 2rem 0 calc(var(--nav-width) + 2rem);
  }

  .header_img {
    width: 40px;
    height: 40px;
  }

  .header_img img {
    width: 45px;
  }

  .l-navbar {
    left: 0;
    padding: 1rem 1rem 0 0;
  }
}

/* toggle switch */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;;EAEtB,4BAA4B;EAC5B,sBAAsB;;EAEtB,qCAAqC;EACrC,wBAAwB;EACxB,cAAc;AAChB;;AAEA;;;;;;;GAOG;;AAEH;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,MAAM;EACN,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC;;cAEY;EACZ,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE;;;KAGG;;EAEH;IACE,yCAAyC;IACzC,+CAA+C;EACjD;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,OAAO;IACP,sBAAsB;EACxB;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[":root {\n  --header-height: 3rem;\n  --nav-width: 68px;\n  --first-color: #6d28d9;\n\n  --first-color-light: #fdfdfd;\n  --white-color: #f7f6fb;\n\n  --body-font: \"Montserrat\", sans-serif;\n  --normal-font-size: 1rem;\n  --z-fixed: 100;\n}\n\n/* a {\n  text-decoration: none;\n  color: none;\n}\n\na:hover {\n  color: none;\n} */\n\nh1 {\n  font-family: var(--body-font) !important;\n  font-weight: 700;\n}\n\n.header_toggle {\n  color: var(--first-color);\n  font-size: 1.5rem;\n  cursor: pointer;\n}\n\n.header_img {\n  width: 35px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.header_img img {\n  width: 40px;\n}\n\n.l-navbar {\n  top: 0;\n  width: 100%;\n  height: 100vh;\n  padding: 0.5rem 1rem 0 0;\n  transition: 0.5s;\n  z-index: var(--z-fixed);\n  position: relative;\n  @media (max-width: 575px) {\n    height: 95vh;\n  }\n}\n\n.nav {\n  /* height: 100%; */\n  display: flex;\n  flex-direction: column;\n  /* justify-content: space-between; */\n  overflow: hidden;\n  margin-top: 1rem;\n}\n\n.nav_logo,\n.nav_link {\n  display: flex;\n  grid-template-columns: max-content max-content;\n  align-items: center;\n  column-gap: 1rem;\n  padding: 0.5rem 0 0.5rem 1.5rem;\n}\n\n.nav_lock_link {\n  position: relative;\n  margin-bottom: 1.5rem;\n  transition: 0.3s;\n  bottom: 0;\n  /* position: fixed; */\n}\n\n.nav_logo {\n  margin-bottom: 2rem;\n  color: var(--first-color-light);\n}\n\n.nav_logo-icon {\n  font-size: 1.25rem;\n  /* color: var(--white-color); */\n}\n\n.nav_logo-name {\n  color: var(--white-color);\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.nav_link {\n  /* position: relative; */\n  /* color: var(--first-color-light); */\n  /* margin-bottom: 1.5rem;\n  transition: 0.3s;\n  bottom: 0; */\n  /* position: fixed; */\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  @media (max-width: 575px) {\n    bottom: 40px;\n  }\n}\n\n.nav_end_link {\n  display: flex;\n  width: 200px;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.nav_logo:hover,\n.nav_link:hover {\n  /* color: var(--white-color); */\n}\n\n.nav_icon {\n  font-size: 1.25rem;\n}\n\n.show {\n  left: 0;\n}\n\n.body-pd {\n  padding-left: calc(var(--nav-width) + 1rem);\n}\n\n/* .active {\n  color: var(--white-color);\n}\n\n.active::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  width: 2px;\n  height: 32px;\n  background-color: var(--white-color);\n} */\n\n@media screen and (min-width: 768px) {\n  /* body {\n    margin: 0;\n    padding-left: 0;\n  } */\n\n  .header {\n    height: calc(var(--header-height) + 1rem);\n    padding: 0 2rem 0 calc(var(--nav-width) + 2rem);\n  }\n\n  .header_img {\n    width: 40px;\n    height: 40px;\n  }\n\n  .header_img img {\n    width: 45px;\n  }\n\n  .l-navbar {\n    left: 0;\n    padding: 1rem 1rem 0 0;\n  }\n}\n\n/* toggle switch */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\ninput:checked + .slider {\n  background-color: #2196f3;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #2196f3;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
